import React, { Fragment } from 'react';
import {
  InfoTitle,
  InfoText,
  InfoBlock,
  InfoBlockTitle,
  InfoBlockList,
  InfoBlockListColumn,
  InfoBlockItem,
  InfoTextGrey,
  InfoBlockListColumnRight
} from '../../Equipment/banners/info';

export const Info = (props) => {
  const { city } = props;

  return (
    <Fragment>
        <InfoTitle>Смотрите дома, как в кино </InfoTitle>
        <InfoText>
            С ТВ-приставкой для телевизора у вас дома будет центр развлечений. Что такое приставка:<br />
            это оборудование (ресивер), которое подключается к вашему телевизору для приема цифрового сигнала.
        </InfoText>

        <InfoBlock>
            <InfoBlockTitle>Это маленькое устройство открывает большие возможности по просмотру ТВ: </InfoBlockTitle>
            <InfoBlockList>
                <InfoBlockListColumn>
                    <InfoBlockItem>
                        Более 200 каналов. Фильмовые, новостные, спортивные, музыкальные. Каждый найдет, что посмотреть.
                    </InfoBlockItem>
                    <InfoBlockItem>
                        Максимально реалистичное и четкое изображение. Смотрите телепередачи в формате HD и Ultra HD 4K.
                    </InfoBlockItem>
                    <InfoBlockItem>
                        Телевидение без рекламы. Перемотайте её во время захватывающего боевика.
                    </InfoBlockItem>
                </InfoBlockListColumn>
                <InfoBlockListColumnRight>
                    <InfoBlockItem>
                        Свобода от расписания программ. Нужно уехать на выходные во время премьеры любимого сериала? Он дождется вас — отмотайте эфир назад.
                    </InfoBlockItem>
                    <InfoBlockItem>
                        Контроль эфира. Поставьте матч на паузу, если нужно ответить на звонок во время решающего гола.
                    </InfoBlockItem>
                    <InfoBlockItem>
                        Онлайн-кинотеатр. Не ищите фильмы в интернете на подозрительных сайтах. Заходите в онлайн-кинотеатр и смотрите премьеры и классику кино. Более 10000 тысяч фильмов в отличном качестве и с хорошим переводом.
                    </InfoBlockItem>
                </InfoBlockListColumnRight>
            </InfoBlockList>
        </InfoBlock>
        <InfoTextGrey>
            А еще приставка компактная и не займет много места в интерьере.
            Купить приставку для цифрового тв в { city.cityIn } можно онлайн на нашем сайте. Выбирайте: Movix или Movix Pro и попробуйте интерактивное ТВ у себя дома.
        </InfoTextGrey>
    </Fragment>
  );
};
